import {PROMOTION_ROUTER_NEW, PROMOTION_ROUTER_ROOT, PROMOTION_ROUTER_EDIT} from './constants';
import PromotionsList from './PromotionsList';
import PromotionNew from './PromotionNew';
import PromotionEdit from './PromotionEdit';

export const PromotionConfig = {
  router: [
    {
      path: PROMOTION_ROUTER_ROOT,
      component: PromotionsList
    },
    // new
    {
      path: PROMOTION_ROUTER_NEW,
      component: PromotionNew
    },
    // edit
    {
      path: PROMOTION_ROUTER_EDIT,
      component: PromotionEdit
    }
  ]
};

export default PromotionConfig;



// WEBPACK FOOTER //
// ./src/components/Promotions/index.js